
    import {defineComponent} from 'vue';
    import {bool} from 'vue-types';

    import ProfileCreationStepCounter from '@/profile-creation-wizard/common/ui/ProfileCreationStepCounter.vue';

    enum StepActionsEvents {
        CLICK_FINISH = 'click:finish',
        CLICK_NEXT = 'click:next',
        CLICK_PREVIOUS = 'click:previous',
        CLICK_SKIP = 'click:skip',
    }

    export default defineComponent({
        name: 'StepActions',
        components: {
            ProfileCreationStepCounter,
        },
        emits: [StepActionsEvents.CLICK_FINISH, StepActionsEvents.CLICK_NEXT, StepActionsEvents.CLICK_PREVIOUS, StepActionsEvents.CLICK_SKIP],
        props: {
            // Finish
            isDisabledButtonFinish: bool().def(true),
            showButtonFinish: bool().def(false),
            isLoadingButtonFinish: bool().def(false),
            // Next
            isDisabledButtonNext: bool().def(true),
            showButtonNext: bool().def(true),
            isLoadingButtonNext: bool().def(false),
            // Previous
            showButtonPrevious: bool().def(true),
            // Skip
            showButtonSkip: bool().def(false),
            isDisabledButtonSkip: bool().def(false),
        },
        setup(props, {emit}) {
            function handleClickOnFinish(): void {
                emit(StepActionsEvents.CLICK_FINISH);
            }
            function handleClickOnNext(): void {
                emit(StepActionsEvents.CLICK_NEXT);
            }
            function handleClickOnPrevious(): void {
                emit(StepActionsEvents.CLICK_PREVIOUS);
            }
            function handleClickOnSkip(): void {
                emit(StepActionsEvents.CLICK_SKIP);
            }

            function dataTestId(action: string): string {
                return `step-actions-cta-${action}`;
            }

            return {
                handleClickOnFinish,
                handleClickOnNext,
                handleClickOnPrevious,
                handleClickOnSkip,
                dataTestId,
            };
        },
    });
